import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { SelectItem, TreeNode } from "primeng/primeng";
import { StoreCampaignService } from "../../services/store/stores-campaign.service";

@Component({
  selector: 'kv-category-choice',
  template: `
    <div class="ui-g-12 dashboard card card-w-title">
      <div class="ui-g-12 ui-grid-row">
        {{'products.select_product' | translate}}
      </div>
      <form (ngSubmit)="this.onNextClick()" #categoryChoiceForm="ngForm">
        <div class="ui-g-12 ui-grid-row">
          <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.categories" (onChange)="this.onChangeCategory($event)"></p-dropdown>
        </div>
        <div class="ui-g-12 ui-grid-row">
          <p-treeTable *ngIf="this.selectedCategory != null" (onNodeSelect)="this.onNextClick($event)" [value]="this.srvStore.subsectors_tree" selectionMode="{{selectionMode}}"
                       [(selection)]="this.selectedSectors">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'products.category_id' | translate}}</th>
                <th>{{'products.category_description' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr [ttSelectableRow]="rowNode">
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"><i class="fa fa-caret-right"></i></p-treeTableToggler>
                  {{ nicelyIdTreeView(rowData.id) }}
                </td>
                <td>{{rowData.description}}</td>
              </tr>
            </ng-template>
          </p-treeTable>
        </div>
      </form>
    </div>
  `,
  styles: [`
    .kvRoundedButton {
      border: none;
      width: 100%;
      height: 40px;
      border: none;
      background-color: #20417b !important;
      color: #ffffff !important;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.11;
      border-radius: 100px;
    }

    .kvRoundedButton:hover {
      border: #20417b 1px solid !important;
      background-color: #ffffff !important;
      color: #20417b !important;
    }

    .kvRoundedButton:disabled {
      border: gray 1px solid;
      background-color: white !important;
      color: gray !important;
    }

    .kvRoundedButton:disabled:hover {

      border: gray 1px solid !important;
      background-color: white !important;
      color: gray !important;
    }
  `]
})

export class CategoryChoiceComponent implements OnInit, OnChanges {

  @Input() selectionMode: string = "single";
  @Output() onNext: EventEmitter<any> = new EventEmitter();

  categories: SelectItem[];
  selectedCategory: SelectItem;
  selectedSectors: TreeNode[];

  constructor(private srvStore: StoreCampaignService) {
    this.selectedSectors = [];
    this.selectedCategory = null;
    this.categories = [{
      label: "",
      value: "uncategorized"
    }];
    this.srvStore.getCategories().subscribe(res => {
      this.srvStore.categories.forEach(c => {
        this.categories.push({
          label: c.descrizione_subsettore,
          value: c.descrizione_subsettore
        });
      })
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onChangeCategory(item: SelectItem) {
    this.selectedCategory = item;
    this.srvStore.getCategorySubsectors(item.value).subscribe();
  }

  evaluateDepth(sector): number {
    let depth : number = 0;
    let item = Object.assign({}, sector);
    while (item.parent) {
      depth = depth + 1;
      item = item.parent;
    }
    return depth;
  }

  onNextClick() {
    if (this.selectedSectors)
      console.log("sectors", this.selectedSectors);
    if (this.selectedSectors && this.selectionMode == "single") {
      let depth = this.evaluateDepth(this.selectedSectors);
      this.onNext.emit({category: this.selectedSectors, depth: depth});
    }
    else if (this.selectedSectors && this.selectionMode == "multiple")
    {
      let d: number = this.evaluateDepth(this.selectedSectors[0]);
      let check_depth: boolean = true;
      this.selectedSectors.forEach(s => {
        check_depth = check_depth && this.evaluateDepth(s) == d;
      });
      if (check_depth)
        this.onNext.emit({category: this.selectedSectors, depth: d});
      else
        this.onNext.emit({category: this.selectedSectors, depth: null});
    }
  }

  nicelyIdTreeView(ugly) {
    return ugly.split('#')[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/products/category-choice.component.ts